
var qtyInput = document.querySelector('.product-form__qty-input');

var afterShipRecomendations = function() {
    var checkInterval = setInterval(function() {
        var btnRec = document.querySelectorAll(".am_rec_add_to_cart_button");
        
        if (btnRec.length > 0) {
            console.log('Element(s) found', btnRec);

            clearInterval(checkInterval); // Stop checking once the element(s) is/are found
            
            btnRec.forEach(function(button) {
                // Add click event listener
                button.addEventListener("click", function() {
                    console.log('Button clicked');
                    setTimeout(function() {
                        updateCartData()
                    }, 3000);
                });
            });
        } else {
            console.log('Checking for element...');
        }
    }, 1000); // Check every 1000 milliseconds (1 second)
}();

if(qtyInput) {
    var maxQty = qtyInput.dataset?.maxQty;
    var productId = qtyInput.dataset.productId;
    var submitBtn = document.querySelector('.product-form__cart-submit');
    var buyNowBtn = document.getElementById('sqBuyNowBtn');
    var qtyError = document.querySelector('.product-stock-error');

    qtyInput.addEventListener('blur', function() {
        maxQty = qtyInput.dataset.maxQty;
        if(Number(qtyInput.value) > Number(maxQty)) {
            qtyInput.value = maxQty;
        }
    })

    async function fetchCartJSON() {
        var response = await fetch('/cart.js');
        var cart = await response.json();
        return cart;
    }

    var updateMaxQty = function() {
        fetchCartJSON().then(function(cart) {
            var qtyInCart = cart.items;

            qtyInCart.forEach(function(item) {
                if(item.id === Number(productId)) {
                    qtyInput.setAttribute('max', maxQty - item.quantity);
                    qtyInput.setAttribute('data-max-qty', maxQty - item.quantity);
                    maxQty = maxQty - item.quantity;

                    checkQty(maxQty);
                }
            });
        });
    }

    var checkQty = function(maxQty) {
        if (maxQty <= 0) {
            qtyError.classList.add('product-stock-error--show');
            submitBtn.setAttribute('disabled', 'disabled');
            buyNowBtn.setAttribute('disabled', 'disabled');
            qtyInput.value = 0;
        }
    }

    updateMaxQty();
}

function newsletterClick() {
    var windowSize = window.innerWidth;
    var newsletterId;

    if (windowSize > 749) {
        newsletterId = 'newsletter'
    } else {
        newsletterId = 'newsletterMobile'
    }

    document.getElementById(newsletterId).scrollIntoView({
        behavior: 'smooth'
    });
}

// function addCartJSON(formData) {
//     var fbtBtn = document.getElementById('fbtBtn');
//     var fbtError = document.getElementById('fbtError');
//     var fbtErrorText = document.getElementById('fbtErrorText');

//     fbtBtn.setAttribute('disabled', 'disabled');

//     fbtBtn.setAttribute('disabled', 'disabled');
//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//         'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(formData)
//     })
//     .then(response => {
//          response.json().then(function(res) {
//              if (res.status === 422) {
//                 fbtError.classList.add('product-fbt__error--active');
//                 fbtErrorText.innerHTML = res.description
//              } else {
//                 getCartData();

//                 var getProductIds = document.querySelectorAll('[data-mini-product-id]');

//                 var idArray = []

//                 getProductIds.forEach(function(id) {
//                   idArray.push(Number(id.dataset.miniProductId));
//                 });

//                 formData.items.forEach(function(element) {
//                     updateItemCount(element);

//                     var checkForId = idArray.filter(function(el) {
//                         return el === element.id
//                     })

//                     var productToAdd = res.items.filter(function(pro) {
//                         return pro.id === element.id
//                     });

//                     if(checkForId.length) {
//                       editExistingProduct(element, true);
//                       updateTotals();
//                     } else {
//                       createNewProductCard(productToAdd[0], true);
//                       updateTotals();
//                     }



//                 });

//                 sqOpenMiniBasket();
//                 fbtBtn.removeAttribute('disabled');
//              }
//          });
//     })
//     .catch((error) => {
//         console.error('Error:', error);
//     });
// }

function getCartData() {
    var sqMiniBasketEmptyCart = document.getElementById('sqMiniBasketEmptyCart');
    var sqMiniBasketActiveCart = document.getElementById('sqMiniBasketActiveCart');

    fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
            if (cart.item_count === 0) {
                if (!sqMiniBasketEmptyCart.classList.contains('sq-mini-basket__empty-cart--active')) {
                    sqMiniBasketEmptyCart.classList.add('sq-mini-basket__empty-cart--active');
                }

                if (sqMiniBasketActiveCart.classList.contains('sq-mini-basket__active-cart--active')) {
                    sqMiniBasketActiveCart.classList.remove('sq-mini-basket__active-cart--active');
                }
            } else {
                if (sqMiniBasketEmptyCart.classList.contains('sq-mini-basket__empty-cart--active')) {
                    sqMiniBasketEmptyCart.classList.remove('sq-mini-basket__empty-cart--active');
                }

                if (!sqMiniBasketActiveCart.classList.contains('sq-mini-basket__active-cart--active')) {
                    sqMiniBasketActiveCart.classList.add('sq-mini-basket__active-cart--active');
                }
            }
            var cartBubble = document.querySelectorAll('[data-cart-count]');
            cartBubble[0].innerHTML = cart.item_count;
            cartBubble[0].classList.remove('header-actions__cart-count--hide');

            // Called in thresholdbar.js
            updateThresholdAmount(cart);
        })
}

function fbtSubmit() {
    var fbtBtn = document.getElementById('fbtBtn');
    var mainProduct = fbtBtn.dataset.thisProduct;
    var subProducts = fbtBtn.dataset.fbtProducts;
    var productArray = fbtBtn.dataset.fbtProducts.split('|');
    var cleanArray = productArray.filter(n => n);
    cleanArray.push(mainProduct);

    var items = []
    cleanArray.forEach(function(el) {
        items.push({
            'id': Number(el.trim()),
            'quantity': 1
        });
    });

    var formData = {
        items
    }

    addCartJSON(formData);
}

function setCombinedPrice() {
    var prices = document.querySelectorAll('[data-fbt-price]');
    var btn = document.getElementById('fbtBtnPrice');
    var combinedPrice = 0;

    prices.forEach(function(el) {
        var price = el.dataset.fbtPrice.replace('£', '');
        combinedPrice += Number(price);
    })

    var formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
      });

    if (btn) {
        btn.innerHTML = '- ' + formatter.format(combinedPrice);
    }
}

setCombinedPrice();


function sqAddToCart(e) {
    e.preventDefault();

    var productId = document.getElementById('sqAddToBasketBtn').dataset.sqProductId;
    var productQty = document.getElementById('Quantity-product-template').value;
    var qtyError = document.querySelector('.product-stock-error-atc');

    if(productQty > 0) {
        if (qtyError) {
            if (qtyError.classList.contains('product-stock-error--show')) {
                qtyError.classList.remove('product-stock-error--show');
            } 
        }
        
        var item = {
            'id': Number(productId),
            'quantity': Number(productQty)
          };

          sqAddCartJSON(item);
    } else {
        if (qtyError) {
            if (!qtyError.classList.contains('product-stock-error--show')) {
                qtyError.classList.add('product-stock-error--show');
            }
        }
        
    }
}

function updateItemCount(addedProduct) {
    var numberItems = document.getElementById('sqItemCount');
    var newItemTotal = Number(numberItems.dataset.numberOfItems) + Number(addedProduct.quantity);
    var sqItemNumber = document.getElementById('sqItemNumber');

    sqItemNumber.innerHTML = newItemTotal;
    numberItems.setAttribute('data-number-of-items', newItemTotal);
}

function createNewProductCard(data, fbt) {
    var container = document.getElementById('sqContentProducts');
    var hostName = window.location.hostname;
    var miniBasketProductsDiv = document.createElement("div");

    // Image setup
    var miniBasketProductsImageDiv = document.createElement("div");
    var miniBasketProductsImageHref = document.createElement("a");
    var miniBasketProductsImage = document.createElement("img");

    miniBasketProductsDiv.setAttribute('class', 'sq-mini-basket__products');
    miniBasketProductsDiv.setAttribute('data-mini-basket-product', '');
    miniBasketProductsDiv.setAttribute('data-product-qty', data.quantity);
    miniBasketProductsDiv.setAttribute('data-mini-product-id', data.variant_id);
    miniBasketProductsImageDiv.setAttribute('class', 'sq-mini-basket__products-image');
    miniBasketProductsImageHref.setAttribute('href', 'https://' + hostName + data.url);
    miniBasketProductsImage.setAttribute('src', data.image);
    miniBasketProductsImage.setAttribute('alt', data.title);

    miniBasketProductsDiv.appendChild(miniBasketProductsImageDiv);
    miniBasketProductsImageDiv.appendChild(miniBasketProductsImageHref);
    miniBasketProductsImageHref.appendChild(miniBasketProductsImage);

    // Title and Qty setup
    var miniBasketProductsTitleDiv = document.createElement("div");
    var miniBasketProductsTitleH = document.createElement("h4");
    var miniBasketProductsTitleA = document.createElement("a");
    var miniBasketProductsTitleP = document.createElement("p");

    miniBasketProductsTitleDiv.setAttribute('class', 'sq-mini-basket__products-details');
    miniBasketProductsTitleA.setAttribute('href', 'https://' + hostName + data.url);
    miniBasketProductsTitleP.setAttribute('data-mini-product-qty', '');
    miniBasketProductsTitleA.innerHTML = data.title;
    miniBasketProductsTitleP.innerHTML = 'Qty: ' + data.quantity;

    miniBasketProductsDiv.appendChild(miniBasketProductsTitleDiv);
    miniBasketProductsTitleDiv.appendChild(miniBasketProductsTitleH);
    miniBasketProductsTitleH.appendChild(miniBasketProductsTitleA);
    miniBasketProductsTitleDiv.appendChild(miniBasketProductsTitleP);

    // Price setup
    var miniBasketProductsPriceDiv = document.createElement("div");
    var miniBasketProductsPriceP = document.createElement("p");

    if(!fbt) {
        var productPrice = document.getElementById('sqAddToBasketBtn').dataset.sqAddProductPrice;
        var productQty = document.getElementById('Quantity-product-template').value;
        var formattedPrice = productPrice.replace('£', '') * productQty;

        miniBasketProductsPriceDiv.setAttribute('class', 'sq-mini-basket__products-price');
        miniBasketProductsPriceP.setAttribute('data-mini-product-price', formattedPrice);
        miniBasketProductsPriceP.innerHTML = "£" + formattedPrice.toFixed(2);
    } else {
        var product = document.querySelector('[data-fbt-product-id="' + data.variant_id + '"]');
        var productPrice = product.dataset.fbtPrice;
        var formattedPrice = productPrice.replace('£', '');

        miniBasketProductsPriceDiv.setAttribute('class', 'sq-mini-basket__products-price');
        miniBasketProductsPriceP.setAttribute('data-mini-product-price', formattedPrice);
        miniBasketProductsPriceP.innerHTML = productPrice;
    }


    miniBasketProductsDiv.appendChild(miniBasketProductsPriceDiv);
    miniBasketProductsPriceDiv.appendChild(miniBasketProductsPriceP);


    container.appendChild(miniBasketProductsDiv);

  }

//   function editExistingProduct(data, fbt) {
//     var productData = ""
//     var productPrice = "";

//     if (!fbt) {
//         var productData = document.getElementById('sqAddToBasketBtn');
//         productPrice = productData.dataset.sqAddProductPrice;
//     } else {
//         var productToAdd = document.querySelector('[data-fbt-product-id="' + data.id + '"]')
//         productPrice = productToAdd.dataset.fbtPrice;
//     }

//     var product = document.querySelector('[data-mini-product-id="' + data.id + '"]');
//     var currentQty = product.dataset.productQty;

//     var formattedProductPrice = productPrice.replace('£', '');
//     var addedPrice = Number(formattedProductPrice) * Number(data.quantity);

//     var currentPrice = product.querySelector('[data-mini-product-price]');
//     var currentFormattedPrice = currentPrice.dataset.miniProductPrice.replace('£', '');

//     var priceToAdd = Number(addedPrice) + Number(currentFormattedPrice);

//     currentPrice.innerHTML = '£' + priceToAdd.toFixed(2);
//     currentPrice.setAttribute('data-mini-product-price', '£' + priceToAdd.toFixed(2));

//     product.setAttribute('data-product-qty', Number(currentQty) + Number(data.quantity));
//     var qtyString = product.querySelector('[data-mini-product-qty]');
//     qtyString.innerHTML = 'Qty: ' + (Number(currentQty) + Number(data.quantity));
//   }

//   function updateTotals() {
//     var productPrices = document.querySelectorAll('[data-mini-product-price]');
//     var combinedPrice = 0
//     productPrices.forEach(price => {
//       var formattedPrice = price.dataset.miniProductPrice.replace('£', '');
//       combinedPrice += Number(formattedPrice);
//     });

//     if (combinedPrice >= 50) {
//         document.getElementById('sqMiniBasketSubTotal').innerHTML = '£' + combinedPrice.toFixed(2);
//         document.getElementById('sqMiniBasketTotal').innerHTML = '£' + combinedPrice.toFixed(2);
//     } else {
//         document.getElementById('sqMiniBasketSubTotal').innerHTML = '£' + combinedPrice.toFixed(2);
//         document.getElementById('sqMiniBasketTotal').innerHTML = '£' + (combinedPrice + 2.99).toFixed(2);
//     }

//   }




  function sqAddCartJSON(formData) {
    var btn = document.getElementById('sqAddToBasketBtn');
    var sqBuyNowBtn = document.getElementById('sqAddToBasketBtn');

    btn.setAttribute('disabled', 'disabled');
    sqBuyNowBtn.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
         response.json().then(function(res) {
             if (res.status === 422) {

             } else {
                updateCartData();
                // updateItemCount(formData);


                // var getProductIds = document.querySelectorAll('[data-mini-product-id]');

                // var idArray = []

                // getProductIds.forEach(id => {
                //   idArray.push(Number(id.dataset.miniProductId));
                // });

                // var checkForId = idArray.filter(function(el) {
                //   return el === formData.id
                // })

                // if(checkForId.length) {
                //   editExistingProduct(formData, false);
                //   sqUpdateDelivery();
                //   updateTotals();
                // } else {
                //   createNewProductCard(res, false);
                //   sqUpdateDelivery();
                //   updateTotals();
                // }

                checkQtyOnSubmit(res.quantity);

                sqOpenMiniBasket();

             }
         });
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }

//   function sqUpdateDelivery() {
//     var productPrices = document.querySelectorAll('[data-mini-product-price]');
//     var deliveryPrice = document.getElementById('sqMiniBasketDeliveryPrice');
//     var combinedPrice = 0

//     productPrices.forEach(price => {
//       var formattedPrice = price.dataset.miniProductPrice.replace('£', '');
//       combinedPrice += Number(formattedPrice);
//     });

//     if (combinedPrice >= 50) {
//         deliveryPrice.innerHTML = 'FREE';
//     } else {
//         deliveryPrice.innerHTML = '£2.99';
//     }
//   }

  function checkQtyOnSubmit(qty) {
    var qtyInput = document.querySelector('.product-form__qty-input');
    var maxQty = qtyInput.dataset.maxQty;
    var submitBtn = document.querySelector('.product-form__cart-submit');
    var buyNowBtn = document.getElementById('sqBuyNowBtn');
    var qtyError = document.querySelector('.product-stock-error');

    maxQty = maxQty - qtyInput.value;

    qtyInput.setAttribute('max', maxQty);
    qtyInput.setAttribute('data-max-qty', maxQty);

    if (maxQty <= 0) {
      qtyError.classList.add('product-stock-error--show');
      submitBtn.setAttribute('disabled', 'disabled');
      if(buyNowBtn) {
        buyNowBtn.setAttribute('disabled', 'disabled');
      }

      qtyInput.value = 0;
    } else {
        qtyInput.value = 1;
        submitBtn.removeAttribute('disabled', 'disabled');

        if(buyNowBtn) {
            buyNowBtn.removeAttribute('disabled', 'disabled');
        }

    }
  }
